import React, {
  DetailedHTMLProps,
  HTMLAttributes,
  PropsWithChildren,
} from 'react'
import { Trans } from 'react-i18next'
import { twMerge } from 'tailwind-merge'
import { MobileIcon } from 'src/editor/shared/ui-lib/mobile-icon'

interface GroupTitleProps
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>,
    PropsWithChildren {
  afterChildren?: React.ReactNode
  /** @deprecated This prop is deprecated. Use withoutHorizontalLine prop instead */
  isFirst?: boolean
  withoutHorizontalLine?: boolean
  className?: string
  isMobile?: boolean
}

export const GroupTitle = ({
  style,
  className,
  children,
  afterChildren,
  isMobile,
  isFirst,
  withoutHorizontalLine,
}: GroupTitleProps) => (
  <>
    {!isFirst && !withoutHorizontalLine && (
      <div className="mt-6 h-[1px] w-full bg-bgTertiary" />
    )}
    <div style={style} className={twMerge('text-heading-5', 'mt-6', className)}>
      <Trans parent="span">{children}</Trans>
      {afterChildren}
      {isMobile && <MobileIcon />}
    </div>
  </>
)
